var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCustomDnbMoneyBag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27.71 38.96"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.16 11.8h0zM19 15.68H8.87c-4.1 3-8.37 8-8.37 12.71 0 6.53 3.38 10.07 13.36 10.07 10.15 0 13.35-3.54 13.35-10.07 0-4.76-4.27-9.71-8.21-12.71zM22.23.5L6.91 3A5.81 5.81 0 019.4 8.09h8.38c0-3.71 4.45-7.59 4.45-7.59z",
    fill: "none",
    stroke: "#a5e1d2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    className: "custom_dnb_money_bag_svg__cls-2",
    d: "M12.43 32.1h2.67l-3.2-4.24 3-3.35h-2.65l-2.31 2.82v-5.82H7.8V32.1h2.32V30l.53-.53zm8.02-7.77a2.79 2.79 0 00-2.32 1.24v-1.24h-2v7.59h2.32v-4.06a1.73 1.73 0 012-1.76h.89v-1.94a1.69 1.69 0 01-.89.17z"
  })))));
}

export default SvgCustomDnbMoneyBag;